import React, { useState } from 'react'
import { Image, Modal } from 'react-bootstrap';

import './style.css'

const ImageDisplay = ({ src, alt, style }) => {

	const [showModal, setShowModal] = useState(false);

	return (
		<div className='imageDisplay'>
			<Image
				src={src} alt={alt} style={style}
				className='img-thumbnail'
				thumbnail
				onClick={() => setShowModal(true)}
			/>
			<Modal 
				show={showModal}
				// fullscreen="sm-down"
				onHide={() => setShowModal(false)}
			>
        <Modal.Header closeButton>
          <Modal.Title>{alt}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
					<Image
						src={src} alt={alt}
						className='img-modal'
						onClick={() => setShowModal(false)}
					/>
				</Modal.Body>
      </Modal>
		</div>
	)
}

export default ImageDisplay